{
  "labels": {
    "paste": "चिटकवा",
    "pasteAsPlaintext": "साधा मजकूर च्या रुपात पेस्ट करा",
    "pasteCharts": "चार्ट चिकटवा",
    "selectAll": "समस्त निवडा",
    "multiSelect": "निवडित तत्व जोडा",
    "moveCanvas": "पटल हलवा",
    "cut": "कापा",
    "copy": "प्रतिलिपी",
    "copyAsPng": "PNG रूपे फळी वर कॉपी करा",
    "copyAsSvg": "SVG रूपे फळी वर कॉपी करा",
    "copyText": "लिखित रूपे फळी वर कॉपी करा",
    "copySource": "स्त्रोत फळी वर कॉपी करा",
    "convertToCode": "सांकेतिक लिपित रूपांतरित करा",
    "bringForward": "पुढे पुढे आणा",
    "sendToBack": "सर्वात मागे करा",
    "bringToFront": "सर्वात पुढे आणा",
    "sendBackward": "मागे मागे करा",
    "delete": "हटवा",
    "copyStyles": "शैली कॉपी करा",
    "pasteStyles": "कॉपी केलेली शैली वापरा",
    "stroke": "रेघे चा रंग",
    "background": "पार्श्वभूमी",
    "fill": "भरा",
    "strokeWidth": "रेघ रुंदी",
    "strokeStyle": "रेघ शैली",
    "strokeStyle_solid": "भरीव",
    "strokeStyle_dashed": "तुटित तुटित",
    "strokeStyle_dotted": "ठिपके ठिपके",
    "sloppiness": "गबाळेपणा",
    "opacity": "अपारदर्शक्ता",
    "textAlign": "मजकूर संरेखन",
    "edges": "किनारी",
    "sharp": "टोचरं",
    "round": "गोलाकार",
    "arrowheads": "बाण टोक",
    "arrowhead_none": "कुठलाहि नाही",
    "arrowhead_arrow": "बाण",
    "arrowhead_bar": "दांडुक",
    "arrowhead_circle": "",
    "arrowhead_circle_outline": "",
    "arrowhead_triangle": "त्रिकोण",
    "arrowhead_triangle_outline": "",
    "arrowhead_diamond": "",
    "arrowhead_diamond_outline": "",
    "fontSize": "अक्षर आकार",
    "fontFamily": "अक्षर समूह",
    "addWatermark": "\"एक्सकेलीड्रॉ ने बनवलेलं\" जोडा",
    "handDrawn": "हातानी बनवलेलं",
    "normal": "सामान्य",
    "code": "सांकेतिक लिपि",
    "small": "छोटे",
    "medium": "मध्यम",
    "large": "मोठं",
    "veryLarge": "फार मोठं",
    "solid": "भरीव",
    "hachure": "हैशूर रेखांकन",
    "zigzag": "वाकडी तिकड़ी",
    "crossHatch": "आडव्या रेघा",
    "thin": "पातळ",
    "bold": "जाड",
    "left": "डावं",
    "center": "मधे",
    "right": "उजवं",
    "extraBold": "जास्त जाड",
    "architect": "वास्तुविद्याविशारद",
    "artist": "कलाकार",
    "cartoonist": "व्यंग्य चित्रकार",
    "fileTitle": "फाईलचे नाव",
    "colorPicker": "रंग निवडक",
    "canvasColors": "कॅनवास वर वापरलेले",
    "canvasBackground": "पटल पार्श्वभूमि",
    "drawingCanvas": "चित्र पटल",
    "layers": "स्तर",
    "actions": "क्रिया",
    "language": "भाषा",
    "liveCollaboration": "ज्वलंत सहयोग...",
    "duplicateSelection": "प्रतिलिपि",
    "untitled": "अशीर्षकांकित",
    "name": "नाव",
    "yourName": "तुमचे नाव",
    "madeWithExcalidraw": "एक्सकेलीड्रॉ ने बनवलेलं",
    "group": "समूह निवड",
    "ungroup": "समूह निवड ला रद्द करा",
    "collaborators": "Sahayog",
    "showGrid": "ग्रिड दाखवा",
    "addToLibrary": "संग्रह मधे सम्मिलित करा",
    "removeFromLibrary": "संग्रहातून काढ़ा",
    "libraryLoadingMessage": "संग्रह लोड होत आहे…",
    "libraries": "संग्रह देखे",
    "loadingScene": "दृश्य लोड होत आहे…",
    "align": "संरेखित करा",
    "alignTop": "वर संरेखित करा",
    "alignBottom": "खाली संरेखित करा",
    "alignLeft": "डावा बाजूला संरेखित करा",
    "alignRight": "उजव्या बाजूला संरेखित करा",
    "centerVertically": "मधल्या मधे उभं संरेखित करा",
    "centerHorizontally": "मधल्या मधे आडवं संरेखित करा",
    "distributeHorizontally": "आडवं वितरित करा",
    "distributeVertically": "उभं वितरित करा",
    "flipHorizontal": "आडवं फ्लिप करा",
    "flipVertical": "उभं फ्लिप करा",
    "viewMode": "पहायची पद्धत",
    "share": "सामायिक करा",
    "showStroke": "रेघ रंग निवड यंत्र दाखवा",
    "showBackground": "पार्श्वभूमि: रंग निवड यंत्र दाखवा",
    "toggleTheme": "शैली बदला",
    "personalLib": "वैयक्तिक संग्रह",
    "excalidrawLib": "एक्सकेलीड्रॉ संग्रह",
    "decreaseFontSize": "अक्षर आकार छोटा करा",
    "increaseFontSize": "अक्षर आकार मोठा करा",
    "unbindText": "लेखन संबंध संपवा",
    "bindText": "शब्द समूह ला पात्रात घ्या",
    "createContainerFromText": "मजकूर कंटेनर मधे मोडून दाखवा",
    "link": {
      "edit": "दुवा संपादन",
      "editEmbed": "कड़ी सम्पादित करा आणि रुतवा",
      "create": "दुवा तयार करा",
      "createEmbed": "नवीन कड़ी बनवा आणि रुतवा",
      "label": "दुवा",
      "labelEmbed": "कड़ी आणि रूतवणे",
      "empty": "कुठलिही कड़ी दिली नाही"
    },
    "lineEditor": {
      "edit": "रेघ संपादन",
      "exit": "रेघ संपादकाबाहेर"
    },
    "elementLock": {
      "lock": "कुलूपात ठेवा",
      "unlock": "कुलूपातून बाहेर",
      "lockAll": "सर्व कुलूपात ठेवा",
      "unlockAll": "सर्व कुलूपातून बाहेर"
    },
    "statusPublished": "प्रकाशित करा",
    "sidebarLock": "साइडबार उघडं ठेवा",
    "selectAllElementsInFrame": "चौकटीतले सर्व तत्वांचे चयन करा",
    "removeAllElementsFromFrame": "चौकटीतून सर्व काढून टाका",
    "eyeDropper": "चित्रफलकातून रंग निवडा",
    "textToDiagram": "",
    "prompt": ""
  },
  "library": {
    "noItems": "अजून कोणतेही आइटम जोडलेले नाही...",
    "hint_emptyLibrary": "पटल वर एक वस्तु निवडुन एथे जोडा, किव्हा एक संग्रह जन कोष कडुन खाली स्थापित करा.",
    "hint_emptyPrivateLibrary": "ईथे जोडण्या साठी पटल वरून एक वस्तु निवडा."
  },
  "buttons": {
    "clearReset": "पटल पुसा",
    "exportJSON": "फ़ाइलमधे बाहेर ठेवा",
    "exportImage": "प्रतिमा निर्यात करा...",
    "export": "येथे सुरक्षित करा...",
    "copyToClipboard": "फळी वर कॉपी करा",
    "save": "वर्तमान फ़ाइल मधे जतन करा",
    "saveAs": "ह्या नावाने जतन करा",
    "load": "उघडा",
    "getShareableLink": "सामायिके साठी दुवा प्राप्त करा",
    "close": "बंद करा",
    "selectLanguage": "भाषा निवड करा",
    "scrollBackToContent": "पहलेचा मजकुर वर मागे स्क्रॉल करा",
    "zoomIn": "मोठं करून पहा",
    "zoomOut": "छोटं करून पहा",
    "resetZoom": "छोटं मोठं करणं बंद करा",
    "menu": "यादि",
    "done": "झालं",
    "edit": "संपादित करा",
    "undo": "पूर्ववत करा",
    "redo": "पुन्हा करा(&R)",
    "resetLibrary": "संग्रह पुनर्स्थित करा",
    "createNewRoom": "एक नवी खोली बनवा",
    "fullScreen": "पूर्ण दृश्यपटल",
    "darkMode": "अंधार स्थिथि",
    "lightMode": "उजेड स्थिति",
    "zenMode": "ध्यानग्र स्थिति",
    "objectsSnapMode": "वस्तूंपासून पकड़ा",
    "exitZenMode": "ध्यानग्र स्थितितून बाहेर",
    "cancel": "रद्द",
    "clear": "स्वछ",
    "remove": "हटवा",
    "embed": "रुतवणे उलटे करा",
    "publishLibrary": "प्रकाशित करा",
    "submit": "जमा करा",
    "confirm": "पुष्टि करा",
    "embeddableInteractionButton": "संवादा साठी क्लिक करा"
  },
  "alerts": {
    "clearReset": "पटल स्वच्छ होणार, तुम्हाला खात्री आहे का?",
    "couldNotCreateShareableLink": "सामायी करण करण्या योग्य दुवा नाही बनवता आला.",
    "couldNotCreateShareableLinkTooBig": "सामायी करण करण्या योग्य दुवा नाही बनवता आला: दृश्य फार मोठं आहे",
    "couldNotLoadInvalidFile": "अवैध फ़ाइल लोड करता आली नाही",
    "importBackendFailed": "बैकएंड हून मागवणे विफल झाले.",
    "cannotExportEmptyCanvas": "रिकामा पटल जतन करता येत नाही.",
    "couldNotCopyToClipboard": "पटल वर कॉपी नाही झाली.",
    "decryptFailed": "डीक्रिप्ट करता आले नाही.",
    "uploadedSecurly": "अपलोड या टोकापासून त्या टोकापर्यंत कूटबद्धित करून सुरक्षित केले गेले आहे, हयाचा अर्थ असा की एक्सकेलीड्रॉ सर्व्हर आणि तृतीय पक्ष मजकूर वाचू शकत नाहीत.",
    "loadSceneOverridePrompt": "बाह्य रेखाचित्र लोड केल्याने तुमची तुमचा विद्यमान मजकूर बदलेल. हे काम तुम्हाला चालू ठेवायचे आहे का?",
    "collabStopOverridePrompt": "सत्र थांबवल्याने तुमचे पूर्वीचे, स्थानिकरित्या संग्रहित रेखाचित्र अधिलिखित होईल. तुला खात्री आहे?\n\n(तुम्हाला तुमचे स्थानिक रेखाचित्र ठेवायचे असल्यास, त्याऐवजी फक्त ब्राउझर टॅब बंद करा.)",
    "errorAddingToLibrary": "संग्रहात तत्व जोडू शकलो नाही",
    "errorRemovingFromLibrary": "संग्रहातून तत्व काढू शकलो नाही",
    "confirmAddLibrary": "हे तुमच्या संग्राहात {{numShapes}} आकार (एक किव्हा अनेक) जोडेल. तुला खात्री आहे?",
    "imageDoesNotContainScene": "या प्रतिमेमध्ये कोणताही दृश्य डेटा असल्याचे दिसत नाही. बाहेर जतन करताना तुम्ही दृश्य रुतवले होते का?",
    "cannotRestoreFromImage": "प्रतिमा फ़ाइल पासून दृश्य पुनः रचित नाही झाला",
    "invalidSceneUrl": "दिलेल्या यू-आर-एल पासून दृश्य आणू शकलो नाही. तो एकतर बरोबार नाही आहे किंवा त्यात वैध एक्सकेलीड्रॉ जेसन डेटा नाही.",
    "resetLibrary": "पटल स्वच्छ होणार, तुम्हाला खात्री आहे का?",
    "removeItemsFromsLibrary": "संग्रहातून {{count}} तत्व (एक किव्हा अनेक) काढू?",
    "invalidEncryptionKey": "कूटबद्धन कुंजी 22 अक्षरांची असणे आवश्यक आहे. थेट सहयोग अक्षम केले आहे.",
    "collabOfflineWarning": "इंटरनेट कनेक्शन उपलब्ध नाही.\nतुमचे बदल जतन केले जाणार नाहीत!"
  },
  "errors": {
    "unsupportedFileType": "असमर्थित फाइल प्रकार.",
    "imageInsertError": "प्रतिमा आत घालता येत नाही. नंतर पुन्हा प्रयत्न करा...",
    "fileTooBig": "फाइल फार मोठी आहे. आकाराची कमाल परवानगी {{maxSize}} आहे.",
    "svgImageInsertError": "एस-वी-जी प्रतिमा आत घालवू शकलो नाही. एस-वी-जी-मार्क-अप यंत्र अयोग्य आहे.",
    "failedToFetchImage": "प्रतिमा आणणे नाही जमले.",
    "invalidSVGString": "अयोग्य एस-वी-जी.",
    "cannotResolveCollabServer": "कॉलेब-सर्वर हे पोहोचत नाही आहे. पान परत लोड करायचा प्रयत्न करावे.",
    "importLibraryError": "संग्रह प्रतिस्थापित नाही करता आला",
    "collabSaveFailed": "काही कारणा निमित्त आतल्या डेटाबेसमध्ये जतन करू शकत नाही। समस्या तशिस राहिल्यास, तुम्ही तुमचे काम गमावणार नाही याची खात्री करण्यासाठी तुम्ही तुमची फाइल स्थानिक जतन करावी.",
    "collabSaveFailed_sizeExceeded": "लगता है कि पृष्ठ तल काफ़ी बड़ा है, इस्कारण अंदरूनी डेटाबेस में सहेजा नहीं जा सका। किये काम को खोने न देने के लिये अपनी फ़ाइल को स्थानीय रूप से सहेजे।\n\nबॅकएंड डेटाबेसमध्ये जतन करू शकत नाही, कॅनव्हास खूप मोठा असल्याचे दिसते. तुम्ही तुमचे काम गमावणार नाही याची खात्री करण्यासाठी तुम्ही फाइल स्थानिक पातळीवर जतन करावी.",
    "imageToolNotSupported": "प्रतिमां अक्षम केली गेली आहेत.",
    "brave_measure_text_error": {
      "line1": "असं वाटते की तुम्हीं Brave ब्राउज़र वापरतात आहात आणि त्या बरोबार <bold>आक्रामक पद्धति चें बोटांचे ठसे </bold> हां सेटिंग्स चा विकल्प चयन केलेला आहे.",
      "line2": "हे तुमच्या चित्रांच्या <bold>पाठ तत्वांनां </bold> खंडित करू शकतात.",
      "line3": "तुम्हाला आमच्या कड़ून खूप आग्रह आहे की हे सेटिंग्स मधले चयन नका करु. <link>हे अनुक्रम </link> हे कसे करावे हे दाखवु शकते.",
      "line4": "ही सेटिंग अक्षम करूनही पृष्ठ योग्यरित्या प्रदर्शित होत नसल्यास, आमच्या GitHub वर <issueLink>समस्या</issueLink> सबमिट करा, किव्हा <discordLink>डिस्कॉर्ड</discordLink> वर आम्हाला लिहा"
    },
    "libraryElementTypeError": {
      "embeddable": "रुतलेले तत्व समूह कोषात जोडले जाऊ शकत नाही.",
      "iframe": "आयफ़्रेम तत्व समूहकोषात जोडला जाऊ शकत नाही.",
      "image": "प्रतिमा समूह कोषात जोड़ायचे लवकरच येत आहेत!"
    },
    "asyncPasteFailedOnRead": "चिटकवता नाही जमले ( सिस्टम क्लिप्बॉर्ड पासून वाचणे नाही जमले).",
    "asyncPasteFailedOnParse": "चिटकवता नाही जमले.",
    "copyToSystemClipboardFailed": "क्लिपबोर्ड वर प्रतिलिपि करणे नाही जमले."
  },
  "toolBar": {
    "selection": "निवड",
    "image": "प्रतिमा आत घाला",
    "rectangle": "आयत",
    "diamond": "चौकोन आकाराचा",
    "ellipse": "अंडाकार",
    "arrow": "बाण",
    "line": "रेखा",
    "freedraw": "रेखांकित करा",
    "text": "टेक्स्ट",
    "library": "संग्रह",
    "lock": "निवडलेले यंत्र चित्रकरण झाल्या नंतर ही सक्रिय ठेवा",
    "penMode": "पेन चा मोड - स्पर्श टाळा",
    "link": "निवडलेल्या आकारासाठी दुवा जोडा/बदल करा",
    "eraser": "खोड रबर",
    "frame": "चौकट यंत्र",
    "magicframe": "वायरफ़्रेम पासून सांकेतिक लिपि",
    "embeddable": "वेब रुतवा",
    "laser": "लेसर टॉर्च",
    "hand": "हात ( सरकवण्या चे उपकरण)",
    "extraTools": "आणिक यंत्रे",
    "mermaidToExcalidraw": "मर्मेड पासून एक्सकाली मधे",
    "magicSettings": "कृतिम बुद्दिवत्ता सेटिंग्स"
  },
  "headings": {
    "canvasActions": "पटल क्रिया",
    "selectedShapeActions": "निवडित आकार क्रिया",
    "shapes": "आकार"
  },
  "hints": {
    "canvasPanning": "कॅनव्हास सरकवण्या साठी, ड्रॅग करताना माउस व्हील धरा किंवा स्पेसबार दाबून ठेवा अथवा हात वालं उपकरण वापरा",
    "linearElement": "अनेक बिंदु साठी क्लिक करा, रेघे साठी ड्रैग करा",
    "freeDraw": "क्लिक आणि ड्रैग करा, झालं तेव्हा सोडा",
    "text": "टीप: तुम्हीं निवड यंत्रानी कोठेही दुहेरी क्लिक करून टेक्स्ट जोडू शकता",
    "embeddable": "वेबसाइट रुतोण्या साठी दाबून-खेचा (क्लिक-ड्रैग करा)",
    "text_selected": "लेखन संपादन साठी दुहेरी क्लिक करा किव्हा एंटर दाबा",
    "text_editing": "संपादन संपवायचं असल्यास एस्केप दाबा किव्हा कंट्रोल या कम्मांड बरोबार एंटर दाबा",
    "linearElementMulti": "शेवटच्या बिंदु वर क्लिक करा किव्हा एस्केप या एंटर दाबा",
    "lockAngle": "शिफ्ट धरून तुम्ही कोन मर्यादित करू शकता",
    "resize": "आकार छोटा मोठा करताना SHIFT धरून तुम्ही प्रमाण मर्यादित करू शकता, \nकेंद्रापासून आकार छोटा मोठा करण्यासाठी ALT धरून ठेवा",
    "resizeImage": "SHIFT धरून तुम्ही मुक्तपणे आकार मोठा छोटा करु शकता,\nकेंद्रापासून आकार मोठा छोटा करण्यासाठी ALT धरून ठेवा",
    "rotate": "फिरवत असताना शिफ्ट धरून तुम्ही कोन मर्यादित करू शकता",
    "lineEditor_info": "पॉइंट संपादित करण्यासाठी CtrlOrCmd दाबून ठेवुन डबल-क्लिक करा किंवा CtrlOrCmd + Enter बरोबर दाबा",
    "lineEditor_pointSelected": "बिंदु (एक किव्हा अनेक) काढ़ण्या साठी डिलीट की दाबा,\nCtrlOrCmd बरोबार D प्रति साठी,\nकिव्हा ड्रेग हलवण्या साठी",
    "lineEditor_nothingSelected": "संपादित करण्यासाठी एक बिंदू निवडा (अनेक निवडण्यासाठी SHIFT धरून ठेवा),\nकिंवा Alt धरून ठेवा आणि नवीन बिंदू जोडण्यासाठी क्लिक करा",
    "placeImage": "प्रतिमा ठेवण्यासाठी क्लिक करा, किंवा त्याचा आकार बदलण्या साठी क्लिक करा आणि ड्रॅग करा",
    "publishLibrary": "आपला खाजगी संग्रह प्रकाशित करा",
    "bindTextToElement": "मजकूर जोडण्यासाठी एंटर की दाबा",
    "deepBoxSelect": "खोल निवड ह्या साठी कंट्रोल किव्हा कमांड दाबून ठेवा, आणि बाहेर खेचणे वाचवण्या साठी पण",
    "eraserRevert": "खोडण्या साठी घेतलेल्या वस्तु ना घेण्या साठी Alt दाबून ठेवावे",
    "firefox_clipboard_write": "हे वैशिष्ट्य \"dom.events.asyncClipboard.clipboardItem\" फ्लॅग \"सत्य\" वर सेट करून शक्यतो सक्षम केले जाऊ शकते. Firefox मध्ये ब्राउझर फ्लॅग बदलण्यासाठी, \"about:config\" पृष्ठावर जा.",
    "disableSnapping": "स्नैपिंग अक्षम करण्या साठी CtrlOrCmd दाबून ठेवा"
  },
  "canvasError": {
    "cannotShowPreview": "पूर्वावलोकन दाखवू शकत नाही",
    "canvasTooBig": "पटल खूप जास्त मोठा असू शकतो.",
    "canvasTooBigTip": "टीप: दूर चा तत्व थोडं जवळ आणण्याचा प्रयत्न करावा."
  },
  "errorSplash": {
    "headingMain": "त्रुटि आली. परत प्रयत्न करा <button>ह्या पानाला पुनः लोड करा.</button>",
    "clearCanvasMessage": "रीलोडिंग होत नसल्यास, परत प्रयत्न करा <button>पटल स्वच्छ करित आहे.</button>",
    "clearCanvasCaveat": " त्यामुळे केलेल्या कामाचे नुकसान होईल ",
    "trackedToSentry": "त्रुटि क्रमांक के साथ त्रुटि {{eventId}} आमच्या प्रणाली नी निरीक्षण केले होते.",
    "openIssueMessage": "त्रुटीत तुमची दृश्य माहिती समाविष्ट न करण्यासाठी आम्ही खूप सावध होतो. तुमचा सीन खाजगी नसल्यास, कृपया आम्हाला पुढ च्या कारवाई साठी सम्पर्क साधा <button>त्रुटि व्यवस्थापन.</button> कृपया गिटहब समस्येमध्ये कॉपी आणि पेस्ट करून खालिल माहिती समाविष्ट करा.",
    "sceneContent": "दृश्य विषय:"
  },
  "roomDialog": {
    "desc_intro": "तुम्‍ही तुमच्‍या सध्‍याच्‍या दृश्यासाठी लोकांना आपल्‍यासह सहयोग करण्‍यासाठी आमंत्रित करू शकता.",
    "desc_privacy": "काळजी करू नका, सत्र या टोकापासून त्या टोकापर्यंत कूटबद्धता वापरते, त्यामुळे तुम्ही जे काही काढाल ते खाजगी राहील. तुम्ही काय घेऊन आला आहात हे आमचा सर्व्हर ही देखील पाहू शकत नाही.",
    "button_startSession": "सत्र सुरु करा",
    "button_stopSession": "सत्र थाम्बवा",
    "desc_inProgressIntro": "थेट सहयोग सत्र चालू आहे.",
    "desc_shareLink": "तुम्ही ज्यांच्याशी सहयोग करू इच्छिता त्यांच्याशी ही दुवा सामायिक करा:",
    "desc_exitSession": "सत्र थांबवल्याने तुम्हीं खोली तून बाहेर याल, तरिही तुम्ही स्थानिक पातळीवर दृश्यासह काम करु शकाल. लक्षात ठेवा की याचा इतर लोकांवर परिणाम होणार नाही आणि ते त्यांच्या आवृत्तीवर सहयोग करित राहातील.",
    "shareTitle": "एक्सकेलीड्रॉ वर थेट सहयोग सत्रात सामील व्हा"
  },
  "errorDialog": {
    "title": "त्रुटि"
  },
  "exportDialog": {
    "disk_title": "डिस्क मधे जतन करा",
    "disk_details": "सीन डेटा बाहेर एक फ़ाइल मधे जतन करा, त्या फ़ाइल मधुम तो डेटा नंतर परत आणु शकता.",
    "disk_button": "फ़ाइल मधे जतन करा",
    "link_title": "सामायिके साठी दुवा",
    "link_details": "नुसतं वाचु देणारा दुवा चा स्वरूपे बाहेर ठेवा.",
    "link_button": "दुवा स्वरूपे बाहेर ठेवा",
    "excalidrawplus_description": "दृश्य तुमच्या एक्सकेलीड्रॉ कार्यक्षेत्र मधे जतन करा.",
    "excalidrawplus_button": "बाहेर ठेवा",
    "excalidrawplus_exportError": "एक्सकेलीड्रॉ मधे बाहेर ठेवता नाही येत..."
  },
  "helpDialog": {
    "blog": "आमचा ब्लॉग वाचा",
    "click": "क्लिक करा",
    "deepSelect": "खोल निवड",
    "deepBoxSelect": "चौकट मधे खोल निवड करा आणि बाहेर ओढणे वाचवा",
    "curvedArrow": "वक्र बाण",
    "curvedLine": "वक्र रेघ",
    "documentation": "कागदपत्रे",
    "doubleClick": "दुहेरी क्लिक",
    "drag": "ओढा",
    "editor": "संपादक",
    "editLineArrowPoints": "रेघ/तीर बिंदु सम्पादित करा",
    "editText": "पाठ्य सम्पादित करा/ लेबल जोडा",
    "github": "समस्या मिळाली? प्रस्तुत करा",
    "howto": "आमच्या मार्गदर्शकाचे अनुसरण करा",
    "or": "किंवा",
    "preventBinding": "बाण बंधन होणं टाळा",
    "tools": "अवजार",
    "shortcuts": "कीबोर्ड शॉर्टकट",
    "textFinish": "संपादन संपले (मजकूर संपादन)",
    "textNewLine": "नवी ओळ जोडा (मजकूर संपादक)",
    "title": "मदत",
    "view": "दृश्य",
    "zoomToFit": "सर्व तत्व दिसतील असे दृश्यरूप आकार करा",
    "zoomToSelection": "निवडी प्रयंत दृश्यरूप आकार करा",
    "toggleElementLock": "कुलूपातून आत/बाहेर निवड",
    "movePageUpDown": "पान वर/खाली करा",
    "movePageLeftRight": "पान डावी/उजवी कडे करा"
  },
  "clearCanvasDialog": {
    "title": "पटल स्वच्छ करा"
  },
  "publishDialog": {
    "title": "संग्रह प्रकाशित करा",
    "itemName": "वस्तु चे नाव",
    "authorName": "लेखक चे नाव",
    "githubUsername": "गिटहब वापरकर्तानाव",
    "twitterUsername": "ट्विटर वापरकर्तानाव",
    "libraryName": "संग्रहाचे नाव",
    "libraryDesc": "संग्रहाचे वर्णन",
    "website": "वेबसाइट",
    "placeholder": {
      "authorName": "तुमचे नाव किव्हा वापरकर्तानाव",
      "libraryName": "तुमचा संग्रहाचे नाव",
      "libraryDesc": "तुमचा संग्रहाचे वर्णन लोकांना संग्रहा बद्दल जाणकारी देतील",
      "githubHandle": "गिटहब हैंडल (वैकल्पिक), एकदा संग्रह पुनरावलोकना साठी जमा केल्या नंतर ही तुम्हीं सम्पादित करु शकता",
      "twitterHandle": "ट्विटर वापरकार्यक नाव (वैकल्पिक), त्यामुळे ट्विटर वर ज़हीरांति साठी कोणाला गुण द्यायचे हे आम्हाला समजेल",
      "website": "दुवा तुमच्या वैयक्तिक वेब-साइट किव्हा कुठे दूसरिकडे (ऐच्छिक) करावा"
    },
    "errors": {
      "required": "आवश्यक आहे",
      "website": "वैध यू-आर-एल द्या"
    },
    "noteDescription": "समाविष्ट करण्या साठी तुमचा संग्रह ह्याचात जमा करा <link>सार्वजनिक संग्रहाचे कोठार</link>इतर लोकांना त्यांच्या रेखाचित्रांमधे वापरण्यासाठी.",
    "noteGuidelines": "संग्रहाला आधी स्वहस्ते स्वीकृती मिळणे आवश्यक आहे. कृपया हे वाचा <link>मार्गदर्शक तत्त्वे</link> जमा करण्या पूर्वी, तुमच्या जवळ एक गिटहब खाते असणे आवश्यक आहे जे संवादा साठी आणिक बदल करण्या साठी लागेल, तरी हे सर्व अगदी आवश्यक नाही आहे.",
    "noteLicense": "जमा करताना तुम्हीं सहमति दाखवतात आहे की संग्रह ह्याचा खाली प्रकाशित होईल <link>एम-आइ-टी परवाना, </link>ज्याचा थोडक्यात अर्थ कोणीही निर्बंधांशिवाय वापरू शकतो.",
    "noteItems": "प्रतैक संग्रहाचे नाव, नीट शोधनासाठी, असणे आवश्यक आहे. खाली दिलेल्या वस्तु समाविष्ट केल्या जातील:",
    "atleastOneLibItem": "सुरु करण्यासाठी, कृपया करून, कमित कमी एक वस्तु तरी निवडा",
    "republishWarning": "टीप: काही निवडक आयटम आधीच प्रकाशित/प्रस्तुत केलेले आहेत. विद्यमान लायब्ररी किंवा प्रस्तुतित आयटम अद्यावित करताना तुम्ही फक्त तो पुन्हा प्रस्तुत करा."
  },
  "publishSuccessDialog": {
    "title": "संग्रह जमा केला",
    "content": "धन्यवाद {{authorName}}. आपला संग्रह पुनरावलोकना साठी जमा झाला आहे. तुम्हीं स्थिति सारखी तपासू सकता<link>इकडे</link>"
  },
  "confirmDialog": {
    "resetLibrary": "संग्रह पुनर्स्थित करा",
    "removeItemsFromLib": "निवडलेले आयटम्स संग्रहातून काढा"
  },
  "imageExportDialog": {
    "header": "प्रतिमा निर्यात करा",
    "label": {
      "withBackground": "पार्श्वभूमि",
      "onlySelected": "फक्त चयन केलेले",
      "darkMode": "अंधारमय स्थिति",
      "embedScene": "दृश्य रुतवा",
      "scale": "क़िती पट",
      "padding": "ग़ादी"
    },
    "tooltip": {
      "embedScene": "दृश्य डेटा निर्यात केलेल्या पी-एन-जी किव्हा एस-वी-जी फ़ाईल मधे सुरक्षीत केला जाईल, त्याने दृश्य पुनः परत आणता येईल. निर्यात केलेली फ़ाईल चा आकार त्याने वाढेल."
    },
    "title": {
      "exportToPng": "पी-एन-जी स्वरूपात बाहेर ठेवा",
      "exportToSvg": "एस-वी-जी स्वरूपात बाहेर ठेवा",
      "copyPngToClipboard": "पी-एन-जी रूपे फळी वर कॉपी करा"
    },
    "button": {
      "exportToPng": "पीएनजी",
      "exportToSvg": "एसविज़ी",
      "copyPngToClipboard": "फळी वर कॉपी करा"
    }
  },
  "encrypted": {
    "tooltip": "तुमचे चित्रे या टोकापासून त्या टोकापर्यंत कूटबद्धतित आहेत, त्या कारणांनी ऐक्सकैलिड्रॉ सर्वर्स ह्यानां ते पहाणं कधीच जमणार नाही.",
    "link": "ब्लॉग पोस्ट ऐक्सकैलिड्रॉ मधे या टोकापासून त्या टोकापर्यंत कूटबद्धतित आहेत"
  },
  "stats": {
    "angle": "कोण",
    "element": "वस्तु",
    "elements": "वस्तु",
    "height": "उंची",
    "scene": "दृश्य",
    "selected": "निवडलेले",
    "storage": "साठवण",
    "title": "अभ्यासू लोगो के लिये आंकडे",
    "total": "योग",
    "version": "आवृत्ती",
    "versionCopy": "कॉपी करायला क्लिक करा",
    "versionNotAvailable": "आवृति उपलब्ध नाही",
    "width": "रुंदी"
  },
  "toast": {
    "addedToLibrary": "संग्रह मधे सम्मिलित",
    "copyStyles": "कॉपी केलेली शैली.",
    "copyToClipboard": "फळी वर कॉपी झाली.",
    "copyToClipboardAsPng": "{{exportSelection}} फळी वर पी-एन-जी स्वरूपात कॉपी झाली\n({{exportColorScheme}})",
    "fileSaved": "फ़ाइल जतन झाली.",
    "fileSavedToFilename": "{filename} मधे जतन झाली",
    "canvas": "पटल",
    "selection": "निवड",
    "pasteAsSingleElement": "एक घटक म्हणून चिपकावण्या साठी {{shortcut}} वापरा,\nकिंवा विद्यमान मजकूर संपादकात चिपकवा",
    "unableToEmbed": "युआरेल रूतवणे प्रतिबंधित आहेत. आपली युआरेल श्वेतसूचित आणण्या साठी कृपया एक मुद्दा ग़िटहब वर उठवा",
    "unrecognizedLinkFormat": "जी युआरेल तुम्हीं रतवली आहे, ती आपेक्षित प्रकारे नाही आहे. कृपया स्त्रोत साइट नी 'रूतवण्या साठी दिलेलि लिपि' चिपकावण्याचा प्रयास करा"
  },
  "colors": {
    "transparent": "पारदर्शक",
    "black": "काळा",
    "white": "पांढरा",
    "red": "लाल",
    "pink": "गुलाबी",
    "grape": "अंगूरी",
    "violet": "जांभळा",
    "gray": "राखाडी",
    "blue": "निळा",
    "cyan": "आकाशी",
    "teal": "हिरवट निळा",
    "green": "हिरवा",
    "yellow": "पिवळा",
    "orange": "केशरी",
    "bronze": "कांस्य"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "तुमचा सर्व डेटा तुमच्या ब्राउझरमध्ये स्थानिक पातळीवर जतन केला जातो.",
      "center_heading_plus": "त्याऐवजी तुम्हाला Excalidraw+ वर जायचे आहे का?",
      "menuHint": "निर्यात, आवड़ी-निवडी, भाषा, ..."
    },
    "defaults": {
      "menuHint": "निर्यात, आवड़ी निवडी आणि आणकिही...",
      "center_heading": "आकृत्या. काढणे. सोपे.",
      "toolbarHint": "एक साधन निवडा आणि चित्रीकरण सुरु करा!",
      "helpHint": "शॉर्टकट आणि सहाय्य"
    }
  },
  "colorPicker": {
    "mostUsedCustomColors": "सर्वात जास्त वापरणीस रंग",
    "colors": "रंग",
    "shades": "रंगछटा",
    "hexCode": "हेक्स कोड",
    "noShades": "ह्या रंगाच्या छटा उपलब्ध नाहित"
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "छवि स्वरूपे निर्यात करा",
        "button": "छवि स्वरूपे निर्यात करा",
        "description": "सीन डेटा बाहेर एक फ़ाइल मधे जतन करा, त्या फ़ाइल मधुन तो डेटा नंतर परत आणु शकता."
      },
      "saveToDisk": {
        "title": "डिस्क मधे जतन करा",
        "button": "डिस्क मधे जतन करा",
        "description": "सीन डेटा बाहेर एक फ़ाइल मधे जतन करा, त्या फ़ाइल मधुन तो डेटा नंतर परत आणु शकता."
      },
      "excalidrawPlus": {
        "title": "एक्षकालीड्रॉ +",
        "button": "एक्षकाली ड्रॉ+ मधे निर्यात करा",
        "description": "दृष्य तुमच्या एक्षकालीड्रॉ+ चा कार्यस्थल मधे जतन करा."
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "फ़ाइल मधुन लोड करा",
        "button": "फ़ाइल मधुन लोड करा",
        "description": "फ़ाइल मधुन लोड केल्या वर ते <bold>तुमचा सध्याचा कामा ठिकाणि एईल </bold><br></br> तुम्हीं तुमचं चित्र एकाधं खाली दिलेलं विकल्प निवडुन पहले सुरक्षीत करु शकता."
      },
      "shareableLink": {
        "title": "लिंक पासून लोड करा",
        "button": "माझ सध्याचे कार्य बदला",
        "description": "बाहरी चित्र लोड केल्या वर ते <bold>तुमचा सध्याचा कामा ठिकाणि एईल </bold><br></br> तुम्हीं तुमचं चित्र एकाधं खाली दिलेलं विकल्प निवडुन पहले सुरक्षीत करु शकता."
      }
    }
  },
  "mermaid": {
    "title": "मर्मेड पासून एक्सकाली मधे",
    "button": "शिरवा",
    "description": "",
    "syntax": "मर्मेड संरचना नियम",
    "preview": "पूर्वावलोकन"
  }
}
